import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { Container,RadioGroup, Radio, SelectPicker, InputPicker, Uploader, Input, Form, Schema, Animation, Button } from 'rsuite';



function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}

const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);
const model_user_info = Schema.Model({
    in_food: Schema.Types.StringType().maxLength(250, 'حداکثر کارکتر 250 میباشد').pattern(/[-.،1234567890آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ]/, 'لطفا به صورت فارسی تایپ نمایید'),
    in_goal_t: Schema.Types.StringType().maxLength(350, 'حداکثر کارکتر 350 میباشد').pattern(/[-.،1234567890آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ]/, 'لطفا به صورت فارسی تایپ نمایید'),
    in_sport_ex: Schema.Types.StringType().maxLength(350, 'حداکثر کارکتر 350 میباشد').pattern(/[-.،1234567890آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ]/, 'لطفا به صورت فارسی تایپ نمایید'),
    in_Injury_ex: Schema.Types.StringType().maxLength(250, 'حداکثر کارکتر 250 میباشد').pattern(/[-.،1234567890آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ]/, 'لطفا به صورت فارسی تایپ نمایید'),
    in_sick: Schema.Types.StringType().maxLength(300, 'حداکثر کارکتر 300 میباشد').pattern(/[-.،1234567890آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئآابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ]/, 'لطفا به صورت فارسی تایپ نمایید'),
    in_training: Schema.Types.StringType().maxLength(350, 'حداکثر کارکتر 350 میباشد').pattern(/[-.،1234567890آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئآابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ]/, 'لطفا به صورت فارسی تایپ نمایید'),
    age: Schema.Types.NumberType('فقط عدد انگلیسی وارد نمایید.').isRequired('این فیلد الزامی است.').isInteger('فقط عدد انگلیسی وارد نمایید.').min(1, 'سن وارد شده صحیح نمی باشد.').max(99, 'سن وارد شده صحیح نمی باشد.'),
    tall: Schema.Types.NumberType('فقط عدد انگلیسی وارد نمایید.').isRequired('این فیلد الزامی است.').isInteger('فقط عدد انگلیسی وارد نمایید.').min(1, 'قد وارد شده صحیح نمی باشد.').max(300, 'قد وارد شده صحیح نمی باشد.'),
    weight: Schema.Types.NumberType('فقط عدد انگلیسی وارد نمایید.').isRequired('این فیلد الزامی است.').isInteger('فقط عدد انگلیسی وارد نمایید.').min(1, 'وزن وارد شده صحیح نمی باشد.').max(500, 'وزن وارد شده صحیح نمی باشد.'),
    in_sleep: Schema.Types.StringType('').maxLength(5, 'لطفا به صورت صحیح وارد نمایید. مثلا ۲۳:۳۰'),
    in_wakeup: Schema.Types.StringType('').maxLength(5, 'لطفا به صورت صحیح وارد نمایید. مثلا ۲۳:۳۰'),
    t_type: Schema.Types.StringType('').isRequired('این فیلد الزامی است.'),

});



export class Training_Single extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            training_id: this.props.params.id,
            training: null,
            buyed: null,
            subed: null,
            UserInfo: null,
            new_info: null,
            UserInfoGallery: [],
        };


    }


    // ---------------- componentDidMount--------------------------

    componentDidMount() {

        Send('page/training/single/' + this.state.training_id, "", true).then((res) => {


            if (!res.data.training) {
                this.props.navigation('/404');
            }
            this.setState({
                training: res.data.training,
                buyed: res.data.buyed,
                subed: res.data.subed,
                UserInfo: res.data.UserInfo,
                UserInfoGallery: res.data.UserGallery,
                new_info: res.data.UserInfo,
            });


        }).catch((err) => { });

        H1.NavHide();

    }

    // ---------------- componentWillUnmount--------------------------


    componentWillUnmount() {

        H1.NavShow();
    }




    // ------------------------- do_edit ----------------------------
    do_edit = () => {


        this.setState({ loader_1: true });

        let data = this.state.new_info;


        Send('page/profile/userinfo/save', data, false).then((res) => {
            H1.notfy_success(res.message)

            localStorage.setItem('cart', this.state.training_id)
            localStorage.setItem('CartType', 'training')
            this.props.navigation('/cart');

            this.setState({ loader_1: false });
        }).catch((err) => {
            this.setState({ loader_1: false });
        });

    }



    // ------------------------- show_error ----------------------------
    show_error = (e) => {
        document.getElementById(Object.keys(e)[0]).scrollIntoView({ behavior: 'smooth' , block: 'center' });
    }



    UploadRemove = (item) => {



        Send('page/training/upload/remove', item, false).then((res) => {
            H1.notfy_success(res.message)
  

        }).catch((err) => {

        });


    }







    render() {

        this.state.training && H1.page_name(this.state.training.name);

        return !this.state.training ? null : (


            <div className="h-100 mt-4">


                <div className='c-row'>

                    <div className="text-center mb-2 py-2 position-relative">

                        <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.props.navigation(-1)}></span>
                        <span className='fs-6'> {this.state.training.name} </span>

                    </div>

                </div>



                <div className='c-row'>


                    {this.state.training && this.state.training.cover &&
                    <img className='br-16' src={this.state.training.cover} width="100%" />
                    }


                    {this.state.training && this.state.training.dis &&
                            <Container className='c-row mt-2 bg-white br-16 p-3'>
                                <p className='ws-br'>{this.state.training.dis}</p>
                            </Container>
                        }

                    </div>



                <div className="c-row text-center mt-4">

                    
                <hr/>


                    <Form model={model_user_info} checkTrigger='none' formDefaultValue={this.state.UserInfo} noValidate={true} align="middle" onChange={(val) => this.setState({ new_info: val })} onCheck={(e) => H1.isEmpty(e) ? this.do_edit() : this.show_error(e)} >

                        <Form.Group controlId="age">
                            <Form.ControlLabel className="px-2" align="right">سن</Form.ControlLabel>
                            <Form.Control id="age" name="age" type="tel" pattern="[0-9]*" inputMode="numeric" className='py-3 px-4 in_s1 NumOnly ltr text-start' placeholder='به سانتی‌متر وارد نمایید' />
                        </Form.Group>

                        <Form.Group controlId="tall">
                            <Form.ControlLabel className="px-2" align="right">قد</Form.ControlLabel>
                            <Form.Control id="tall" name="tall" type="tel" pattern="[0-9]*" inputMode="numeric" className='py-3 px-4 in_s1 NumOnly ltr text-start' placeholder='به سانتی‌متر وارد نمایید' />
                        </Form.Group>

                        <Form.Group controlId="weight">
                            <Form.ControlLabel className="px-2" align="right">وزن</Form.ControlLabel>
                            <Form.Control id="weight" name="weight" type="tel" pattern="[0-9]*" inputMode="numeric" className='py-3 px-4 in_s1 NumOnly ltr text-start' placeholder='به کیلوگرم وارد نمایید' />
                        </Form.Group>

                        <Form.Group controlId="in_goal_t">
                            <Form.ControlLabel className="px-2" align="right">هدف از برنامه</Form.ControlLabel>
                            <Form.Control id="in_goal_t" accepter={Textarea} rows={4} name="in_goal_t" type="text" className='py-3 px-4 in_s1' placeholder='هدف یا درخواست شما از دریافت این برنامه ورزشی' />
                        </Form.Group>
                        
                        <Form.Group controlId="t_type">
                          <Form.ControlLabel className="px-2" align="right"> نوع تمرین</Form.ControlLabel>
                          <Form.Control id="t_type" name="t_type" accepter={RadioGroup} inline>
                                <Radio className='rad_gbw' value="تمرین در خانه">تمرین در خانه</Radio>
                                <Radio className='rad_gbw' value="تمرین در باشگاه">تمرین در باشگاه</Radio>
                          </Form.Control>
                        </Form.Group>

                        <Form.Group controlId="in_sport_ex">
                            <Form.ControlLabel className="px-2" align="right">سابقه ورزشی</Form.ControlLabel>
                            <Form.Control id="in_sport_ex" accepter={Textarea} rows={4} name="in_sport_ex" type="text" className='py-3 px-4 in_s1' placeholder='در صورت داشتن سابقه ورزشی این فیلد را پر کنید' />
                        </Form.Group>

                        <Form.Group controlId="in_Injury_ex">
                            <Form.ControlLabel className="px-2" align="right">سابقه اسیب دیدگی</Form.ControlLabel>
                            <Form.Control id="in_Injury_ex" accepter={Textarea} rows={4} name="in_Injury_ex" type="text" className='py-3 px-4 in_s1' placeholder='در صورت داشتن سابقه اسیب دیدگی این فیلد را پر کنید' />
                        </Form.Group>

                        <Form.Group controlId="in_training">
                            <Form.ControlLabel className="px-2" align="right">روزهای جلسات در هفته</Form.ControlLabel>
                            <Form.Control id="in_training" accepter={Textarea} rows={4} name="in_training" type="text" className='py-3 px-4 in_s1' placeholder='لطفا روزهایی که تمرین می‌کنید را بنویسید' />
                        </Form.Group>

                        {/* 
                    <Form.Group controlId="in_sleep">
                        <Form.ControlLabel className="px-2" align="right">ساعت خواب</Form.ControlLabel>
                        <Form.Control name="in_sleep" type="text"  className='py-3 px-4 in_s1' placeholder='مثلا ۲۳:۳۰' />
                    </Form.Group>


                    <Form.Group controlId="in_wakeup">
                        <Form.ControlLabel className="px-2" align="right">ساعت بیداری</Form.ControlLabel>
                        <Form.Control name="in_wakeup" type="text"  className='py-3 px-4 in_s1' placeholder='مثلا ۰۶:۳۰' />
                    </Form.Group> */}

                        <Form.Group controlId="img">
                            <Form.ControlLabel className="px-2" align="right">  عکس ضمیمه -  اختیاری (حد اکثر: 3 عدد )</Form.ControlLabel>


                            <Uploader
                                disabled={this.state.UserInfoGallery.length >= 3 ? true : false}
                                accept='image/*'
                                listType="picture"
                                fileList={this.state.UserInfoGallery}
                                onRemove={this.UploadRemove}
                                autoUpload={true}
                                action={H1.isDev() ? 'http://localhost:8000/api/app/page/training/upload' : 'https://mg.vactive.app/api/app/page/training/upload'}
                                method='POST'
                                headers={{ 'Authorization': `Bearer ${localStorage.getItem('token')}` }}
                                onSuccess={(response, file) => {
                                    H1.notfy_success(response.message);
                                    this.setState({ UserInfoGallery: response.data });
                                }}
                                onError={(response) => {
                                    H1.notfy_error(response.response.message)
                                    console.log(response)
                                }}

                            >

                                <button type='button'>
                                    <span className='icon-Camera fs-3'></span>
                                </button>

                            </Uploader>

                        </Form.Group>



                        <Button appearance="primary" type="submit" block className='fw-light btn_s1 mt-5 mx-auto' loading={this.state.loader_1}>ثبت درخواست</Button>


                    </Form>



                </div>




            </div>

        )

    }
}

export default withParams(Training_Single);
